import { SVGAttributes } from 'react';

import clsx from 'clsx';

import { iconBaseStyle } from './IconBase.css';
import { IconProps } from './icon';

export const Svg = ({
  className,
  width,
  height,
  style,
  ...props
}: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      className={clsx(iconBaseStyle, className)}
      style={{
        width,
        height,
        ...style,
      }}
      {...props}
    />
  );
};

export const IconBase = ({ ...props }: IconProps & { paths: SVGAttributes<SVGPathElement>[] }) => {
  return (
    <Svg
      width={props.width}
      height={props.height}
      viewBox={props.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      {...props}
    >
      {props.paths.map((path) => (
        <path
          key={path.d}
          d={path.d}
          fillRule={path.fillRule}
          clipRule={path.clipRule}
          fill={path.fill || props.fill}
        />
      ))}
    </Svg>
  );
};

export default IconBase;
